import { LinearProgress } from "@mui/material";
import { MagnifyingGlassIcon, PencilSimpleIcon } from "@phosphor-icons/react";
import { FilterButton, type Props as FilterButtonProps } from "./FilterButton";

type Props = Omit<FilterButtonProps, "fullWidth"> & {
  progress?:
    | {
        variant: "indeterminate";
      }
    | { variant: "determinate"; value: number };
};

export function HeaderSearchButton({ children, progress, ...props }: Props) {
  return (
    <FilterButton fullWidth borderRadius="var(--radius-2xl)" {...props}>
      <div className="flex w-full items-center gap-3">
        <MagnifyingGlassIcon
          size={20}
          className="shrink-0 fill-text-disabled-interactive"
        />

        <div className="overflow-hidden">{children}</div>
        <div className="ms-auto flex shrink-0 gap-1">
          <div className="h-6 w-[1px] bg-stroke-neutral-soft" />
          <PencilSimpleIcon
            size={20}
            className="fill-text-disabled-interactive"
          />
        </div>
      </div>
      {progress ? (
        <LinearProgress
          {...progress}
          sx={{ position: "absolute", bottom: 0, width: "100%", height: "2px" }}
        />
      ) : null}
    </FilterButton>
  );
}
